import * as React from 'react';

import { Box } from 'components/ui';

import { Group } from './styled';
import { IProductDetailListItemGroupProps } from './types';

export const ProductDetailListItemGroup: React.FC<React.PropsWithChildren<
  IProductDetailListItemGroupProps
>> = ({ items, testID = 'product-detail-list-item-group' }) => {
  if (!items?.length) {
    return null;
  }

  return (
    <Group testID={testID}>
      <Box testID="product-detail-list-item-group-items">
        {items.map((item, index) => (
          <Box key={`product-detail-list-item-group-items-${index}`}>{item}</Box>
        ))}
      </Box>
    </Group>
  );
};
